import { davimaDocValidations } from "../docValidation/davima";
import { adiquimica } from "./adiquimica";
import { enplast } from "./enplast";
import { hifi } from "./hifi";
import { inserosale } from "./inserosale";
import { invoiceDeliveryNOteDiscrepancy } from "./invoiceDeliveryNoteDiscrepancy";
import { odooDiscrepancy } from "./odooDiscrepancy";
import { sage200 } from "./sage200";
import { sagex3Es } from "./sagex3";
import { sap4hana } from "./sap4hana";

export const discrepanciesEs = {
  ...hifi,
  ...sage200,
  ...sagex3Es,
  ...sap4hana,
  ...enplast,
  ...adiquimica,
  ...inserosale,
  ...odooDiscrepancy,
  ...invoiceDeliveryNOteDiscrepancy,
  ...davimaDocValidations,
};
